import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Innovaonrentmumbai() {



  const cardData = {
    keyword: " Innova On Rent Mumbai",


"headingDescription": "Royal Route Cab offers premium Innova on rent in Mumbai, providing spacious, comfortable, and reliable travel solutions for families, corporate groups, airport transfers, weddings, and outstation trips. Toyota Innova is one of the most preferred SUVs in India due to its superior comfort, strong suspension, and large seating capacity, making it ideal for long journeys and group travel. Whether you need a local city ride, Mumbai darshan, airport pickup/drop, or multi-day outstation travel, our Innova vehicles ensure a smooth and stress-free experience. We provide well-maintained cars, professional drivers, punctual service, and transparent pricing with no hidden charges. Our fleet includes Innova, Innova Crysta, and premium SUV options available 24/7 with easy booking and instant support.",

"topPlaces": [
  {
    "title": "Mumbai Airport Transfers",
    "description": "Booking an Innova for Mumbai Airport transfers is one of the most convenient options for travelers with luggage or groups. The spacious seating and large boot space make it ideal for airport pickups and drops. Innova ensures a smooth ride even in heavy Mumbai traffic, offering comfort after long flights. Professional drivers track flight timings and provide timely pickups, making the entire airport travel experience stress-free and efficient for both domestic and international passengers."
  },
  {
    "title": "Mumbai Darshan (City Tour)",
    "description": "Innova is perfect for Mumbai darshan tours where families or groups want to explore the city comfortably in one vehicle. Popular attractions like South Mumbai, Marine Drive, Gateway of India, and Bandra can be covered easily in a full-day trip. The comfortable seating and air conditioning make long sightseeing hours enjoyable, especially in Mumbai’s humid weather. It allows flexible stops, photography breaks, and relaxed travel without the hassle of public transport."
  },
  {
    "title": "Outstation Trips from Mumbai",
    "description": "Innova is one of the best choices for outstation travel from Mumbai to destinations like Lonavala, Shirdi, Nashik, Pune, Mahabaleshwar, and Gujarat. Its strong suspension and smooth highway performance make long-distance journeys comfortable. Travelers prefer Innova for multi-day trips due to its reliability, safety, and luggage capacity. :contentReference[oaicite:0]{index=0}"
  },
  {
    "title": "Corporate Travel",
    "description": "For corporate clients, Innova provides a premium and professional travel experience suitable for meetings, events, and employee transportation. The vehicle’s clean interiors, comfortable seating, and quiet ride make it ideal for business travel. Many companies prefer Innova for client pickups and official use due to its reliability and executive feel."
  },
  {
    "title": "Wedding & Event Transportation",
    "description": "Innova is widely used for wedding guest transportation, family functions, and events in Mumbai. Its ability to carry multiple passengers comfortably reduces the need for multiple cars. It ensures coordinated travel for groups, making event logistics smoother and more organized."
  },
  {
    "title": "Family Trips & Group Travel",
    "description": "For family outings and group travel, Innova offers the perfect balance of space, comfort, and affordability. With seating for 6–7 passengers, it allows everyone to travel together without compromising comfort. It is especially suitable for elderly passengers due to its easy seating and smooth ride quality."
  },
  {
    "title": "Long Distance Highway Travel",
    "description": "Innova is known for its strong performance on highways, making it ideal for long-distance travel across states. The vehicle provides stability, safety, and comfort even on rough roads, ensuring a relaxed journey for passengers traveling long hours."
  },
  {
    "title": "Weekend Getaways",
    "description": "Weekend destinations near Mumbai like Alibaug, Matheran, Igatpuri, and Lavasa are best explored with an Innova rental. The spacious vehicle allows travelers to carry luggage, enjoy music, and travel comfortably without worrying about road conditions."
  },
  {
    "title": "Pilgrimage Tours",
    "description": "Innova is highly preferred for religious trips such as Shirdi, Trimbakeshwar, Bhimashankar, and Shani Shingnapur. Its comfort and reliability make it ideal for long spiritual journeys where passengers need a peaceful and smooth travel experience."
  },
  {
    "title": "Multi-Day Tour Packages",
    "description": "For extended tours covering multiple destinations, Innova provides flexibility and convenience. Travelers can plan customized itineraries without depending on fixed schedules, making the journey more enjoyable and personalized."
  }
],






services: [
  {
    name: "Innova on Rent Mumbai",
    description: "Innova on rent in Mumbai offers a premium and spacious travel experience for families, corporate clients, and group travelers. Known for comfort and reliability, Innova is ideal for city travel, airport transfers, and outstation trips. Professional drivers and clean vehicles ensure safety. It guarantees a smooth and comfortable journey."
  },
  {
    name: "Innova Cab Service Mumbai",
    description: "Innova cab service Mumbai provides high-quality transportation with well-maintained vehicles and experienced drivers. This service is perfect for business travel, family trips, and group journeys. Spacious interiors enhance comfort. It ensures a reliable travel experience."
  },
  {
    name: "Toyota Innova Rental Mumbai",
    description: "Toyota Innova rental Mumbai offers a trusted and comfortable vehicle option for long-distance and city travel. Known for durability and performance, this vehicle is ideal for all types of trips. Professional chauffeurs ensure safety. It ensures a pleasant journey."
  },
  {
    name: "Innova Taxi Mumbai",
    description: "Innova taxi Mumbai provides comfortable and spacious rides for individuals and groups. This service is suitable for local travel, airport transfers, and outstation journeys. Clean vehicles and trained drivers ensure comfort. It guarantees a smooth ride."
  },
  {
    name: "Innova Car Hire Mumbai",
    description: "Innova car hire Mumbai offers flexible rental options for personal and business travel. Customers can choose hourly, daily, or outstation packages. Spacious seating and luggage space enhance convenience. It ensures a comfortable travel experience."
  },
  {
    name: "Innova Cab Booking Mumbai",
    description: "Innova cab booking Mumbai allows customers to reserve their ride easily with flexible options. Travelers can choose pickup location, timing, and travel plan. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Innova Taxi Booking Online Mumbai",
    description: "Innova taxi booking online Mumbai provides a quick and convenient way to book your cab. Customers can compare options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Innova Rental Price Mumbai",
    description: "Innova rental price Mumbai varies based on travel distance, duration, and trip type. Transparent pricing ensures no hidden charges. Customers can choose from budget and premium packages. It helps in planning travel costs effectively."
  },
  {
    name: "Innova Taxi Fare Mumbai",
    description: "Innova taxi fare Mumbai is designed to be competitive and affordable. Fare depends on route, trip type, and duration. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Innova One Way Cab Mumbai",
    description: "Innova one way cab Mumbai offers cost-effective travel without return charges. This service is ideal for single-side journeys and airport transfers. Flexible pickup options enhance convenience. It ensures smooth and economical travel."
  },
  {
    name: "Innova Round Trip Cab Mumbai",
    description: "Innova round trip cab Mumbai provides complete travel solutions including return journeys. This service is ideal for outstation travel, business trips, and vacations. Flexible schedules enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Cheap Innova Rental Mumbai",
    description: "Cheap Innova rental Mumbai offers budget-friendly travel options without compromising comfort and safety. Ideal for families and groups looking for affordable luxury travel. Transparent pricing ensures no hidden charges. It ensures economical travel."
  },
  {
    name: "Best Innova Cab Service Mumbai",
    description: "Best Innova cab service Mumbai ensures top-quality vehicles, professional drivers, and excellent customer support. This service focuses on comfort, safety, and punctuality. It guarantees a premium and reliable travel experience."
  },
  {
    name: "Innova Airport Cab Mumbai",
    description: "Innova airport cab Mumbai provides convenient pickup and drop services to and from the airport. Spacious interiors make it ideal for luggage-heavy travel. Timely service ensures stress-free transfers. It guarantees a comfortable airport journey."
  },
  {
    name: "Innova Outstation Cab Mumbai",
    description: "Innova outstation cab Mumbai is perfect for long-distance travel and intercity trips. Spacious seating and smooth performance make it ideal for highways. Professional drivers ensure safety. It ensures a comfortable outstation experience."
  }
],

tableData: [
  ["Innova on Rent Mumbai", "Innova Cab Service Mumbai"],
  ["Toyota Innova Rental Mumbai", "Innova Taxi Mumbai"],
  ["Innova Car Hire Mumbai", "Innova Cab Booking Mumbai"],
  ["Innova Taxi Booking Online Mumbai", "Innova Rental Price Mumbai"],
  ["Innova Taxi Fare Mumbai", "Innova One Way Cab Mumbai"],
  ["Innova Round Trip Cab Mumbai", "Cheap Innova Rental Mumbai"],
  ["Best Innova Cab Service Mumbai", "Innova Airport Cab Mumbai"],
  ["Innova Outstation Cab Mumbai", ""]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Innova on Rent in Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers spacious and comfortable Innova rental in Mumbai, perfect for family trips, airport transfers, and outstation travel."
  },
  {
    WhyChooseheading: "Ideal for Group & Family Travel",
    WhyChoosedescription: "Toyota Innova provides ample seating for 6-7 passengers with large luggage space, making it ideal for group journeys."
  },
  {
    WhyChooseheading: "Experienced & Professional Drivers",
    WhyChoosedescription: "Our drivers are well-trained and experienced in Mumbai and highway routes, ensuring safe and smooth travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Innova Rental Availability",
    WhyChoosedescription: "Our Innova on rent service in Mumbai operates 24/7 for local, airport, and outstation travel needs."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All Innova cars are regularly serviced, sanitized, and maintained for a premium travel experience."
  },
  {
    WhyChooseheading: "Flexible Rental Options",
    WhyChoosedescription: "Choose from hourly rental, full-day packages, one-way, or round-trip bookings as per your travel plan."
  },
  {
    WhyChooseheading: "Trusted SUV Rental Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable Innova rental service in Mumbai with punctual drivers and smooth service."
  }
]

};

const faqData = [
  { question: "Do you provide Innova on rent in Mumbai?", answer: "Yes, Royal Route Cabs offers Innova rental services in Mumbai for local and outstation travel." },
  { question: "What is the price of Innova on rent in Mumbai?", answer: "Innova rental in Mumbai typically starts from ₹17 to ₹20 per km or ₹2000 to ₹4000 per day depending on package and model." },
  { question: "Is Innova suitable for long-distance travel?", answer: "Yes, Innova is ideal for long-distance trips due to its comfort, space, and reliability." },
  { question: "Is rental available 24 hours?", answer: "Yes, our Innova rental service operates 24/7." },
  { question: "Do you provide driver with Innova rental?", answer: "Yes, all rentals include professional drivers." },
  { question: "Can I book Innova for one-way trips?", answer: "Yes, we provide both one-way and round-trip booking options." },
  { question: "Do you provide airport pickup with Innova?", answer: "Yes, we offer Mumbai airport pickup and drop services with Innova cars." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Joshi",
    feedback: "Innova on rent in Mumbai with Royal Route Cabs was a great experience. The vehicle was spacious, clean, and perfect for our family travel needs.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Deshmukh",
    feedback: "Very comfortable Innova rental service in Mumbai. The ride was smooth, the car was well-maintained, and the service felt reliable throughout the journey.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova on Rent Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/innova-on-rent-mumbai.jpg", // replace if needed
  "description": "Book Innova on rent in Mumbai with Royal Route Cabs for comfortable, spacious, and reliable travel. Ideal for family trips, outstation journeys, airport transfers, and corporate travel. Available for one-way and round-trip bookings with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12/km", // indicative per km rate (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/innova-on-rent-mumbai"
  }
};







  return (
    <div>

<Helmet>
  <title>Innova on Rent Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Innova on rent in Mumbai with Royal Route Cabs. Spacious and comfortable 6–7 seater taxi for outstation, airport, and family travel. 24x7 reliable cab service."
  />

  <meta
    name="keywords"
    content="innova on rent mumbai, innova cab service mumbai, toyota innova rental mumbai, innova taxi mumbai, innova car hire mumbai, innova cab booking mumbai, innova taxi booking online mumbai, innova rental price mumbai, innova taxi fare mumbai, innova one way cab mumbai, innova round trip cab mumbai, cheap innova rental mumbai, best innova cab service mumbai, innova airport cab mumbai, innova outstation cab mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/102.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovaonrentmumbai;